import "../index.styles.scss";
import OpenEyeIcon from "../../../icons/open-eye.icon";
import SecStackTable from ".././sec-stack-table";
import { useEffect, useState } from "react";
import AddToolModal from ".././add-tool-modal";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../constants/app.constants";
import SelectClientModal from ".././select-client-modal";
import { useAuth } from "../../../context/Auth";
import { getAPIData, postData } from "../../../../Utils/commonApi";
import { CallToast } from "../../../PriceCalculator/modals/CustomToast";
import ChevronXSIcon from "../../../icons/chevron-lg.icon";

const SecStackReportReviewPage = ({ previewPath = ROUTE_PATHS.subscriptionPortalPages.secStackReportPreviewShare, backPath = ROUTE_PATHS.subscriptionPortalPages.secStackReport }) => {
  const navigate = useNavigate();
  const { authTokens } = useAuth();
  const [selectedClientModalData, setSelectedClientModalData] = useState({ show: false });
  const [addToolModalData, setAddToolModalData] = useState({ show: false });
  const [selectedMSP, setSelectedMSP] = useState({});
  const [reportId, setReportId] = useState(0);
  const location = useLocation();
  const { mspId, passedReportId, forView } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState({});
  const [technologyEnum, setTechnologyEnum] = useState(0);

  const handleAddTool = (tool) => {
    setAddToolModalData({ show: true, modalData: { tool } });
  }

  useEffect(() => {
    if (!forView) {
      setSelectedClientModalData({ show: true })
    }
  }, [])

  useEffect(() => {
    setReportId(passedReportId)
  }, [passedReportId])

  const onPreviewClick = () => {
    navigate(previewPath, {
      state: {
        mspId: mspId ?? selectedMSP.MSPId,
        reportId: reportId,
      }
    });
  }

  const onContinue = (msp) => {
    setSelectedMSP(msp);
    createSecurityStackReport(mspId ?? msp?.MSPId, msp?.MSPName);
    setSelectedClientModalData({ show: false })
  }

  function createSecurityStackReport(id, name) {
    postData(authTokens, "CreateSecurityStackReport", {
      ObjId_Customer: id ?? 0,
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      SecurityStackId: 0,
      MSPName: name ?? '',
    })
      .then((response) => {
        if (response?.Success) {
          setReportId(response?.EntityId)
        } else {
          CallToast("Something went wrong", false, false, "v2style");
        }
      })
      .catch((err) => {
        CallToast("Something went wrong", false, false, "v2style");
        console.log(err);
      });
  }

  async function updateSecurityStackReportVisibility(reportId, visibilityList) {
    postData(authTokens, "UpdateSecurityStackReportVisibility", {
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      SecurityStackReportId: reportId ?? 0,
      SecurityStackReportVisibility_Json: JSON.stringify(visibilityList)
    })
  }

  async function getPageData(mspId, reportId, fromModal = false) {
    if (!fromModal) {
      setLoading(true);
    }
    await getAPIData(16, authTokens, {
      optionEnum1: mspId ?? 0,
      optionEnum2: reportId ?? 0
    }).then((response) => {
      if (response?.mr?.Success) {
        setTableData(response)
        setLoading(false);
      } else {
        setLoading(false);
        CallToast("Something went wrong", false, false, "v2style");
      }
    });
  }

  const onBack = () => {
    navigate(backPath);
  }

  const onActiveChange = (technologyEnum, value) => {
    const updatedVisibilityList = tableData?.SecurityStackReport_List?.map((item) => {
      if (item?.Technology_Enum === technologyEnum) {
        return { ...item, IsActive: value };
      }
      return item;
    })
    setTableData({ ...tableData, SecurityStackReport_List: updatedVisibilityList });
    updateSecurityStackReportVisibility(reportId, updatedVisibilityList?.map((item) => ({
      TechnologyEnum: item?.Technology_Enum,
      TechnologyName: item?.TechnologyName,
      IsVisible: item?.IsActive
    })));
  }

  return (
    <div className="sec-stack-report-page">
      <div className="page-header">
        <div className="d-flex align-items-center gap-16">
          <div className="back-button" onClick={onBack}>
            <ChevronXSIcon />
          </div>
          <h1 className="header-title f-black m-0">
            Security Stack Review
          </h1>
        </div>
        <button className="preview-btn my-button" onClick={onPreviewClick}>
          <OpenEyeIcon className="eye-icon" />
          <span className="f-white">Preview</span>
        </button>
      </div>
      <div id="sec-stack-report-page-content" className="page-content">
        <SecStackTable
          tableData={tableData}
          technologyEnum={technologyEnum}
          setTechnologyEnum={setTechnologyEnum}
          loading={loading}
          getPageData={getPageData}
          forView={forView}
          reportId={passedReportId ?? reportId}
          mspId={mspId}
          selectedMSP={selectedMSP}
          onAddTool={handleAddTool}
          onActiveChange={onActiveChange}
        />
        <AddToolModal
          show={addToolModalData.show}
          reportId={reportId}
          mspId={mspId}
          selectedMSP={selectedMSP}
          hideModal={() => setAddToolModalData(prev => ({ ...prev, show: false }))}
          modalData={addToolModalData.modalData}
          setModalData={setAddToolModalData}
          getPageData={getPageData}
          setLoading={setLoading}
          technologyEnum={technologyEnum}
        />
      </div>
      <SelectClientModal
        setSelectedMSP={setSelectedMSP}
        show={selectedClientModalData.show}
        onCancel={() => setSelectedClientModalData({ show: false })}
        onContinue={onContinue}
      />
    </div>
  )
}

export default SecStackReportReviewPage;
